// Experiencia comercial explicativa. No modifica entitlements, cobros ni facturas.
export const BILLING_GUIDE_STEPS = Object.freeze(["entender", "elegir", "continuar"]);

export function billingJourneyState(access = {}) {
  if (access.reason === "trial_expired") return "trial_expired";
  if (access.isGrace) return "past_due_grace";
  if (["payment_grace_expired", "subscription_paused", "subscription_cancelled", "billing_restricted", "billing_suspended"].includes(access.reason) || access.needsPaymentAction) return "payment_restricted";
  if (access.isTrial) return "trial_active";
  return "active";
}

export function billingJourneyMessage(access = {}) {
  const state = billingJourneyState(access);
  if (state === "trial_expired") return { title: "Terminó tu prueba de 30 días", detail: "Tus datos siguen guardados. Para volver a operar, elegí qué módulos conservar y activá el pago correspondiente.", action: "Armar mi suscripción" };
  if (state === "past_due_grace") return { title: "Tenés un pago pendiente", detail: "Tu período de gracia sigue vigente. Revisá tu suscripción y regularizá el cobro antes de que se pausen las herramientas.", action: "Resolver el pago" };
  if (state === "payment_restricted") return { title: "Tu suscripción necesita atención", detail: "El acceso puede estar limitado por un pago o estado de suscripción. Conservás los datos y podés consultar cómo recuperarlo.", action: "Revisar mi suscripción" };
  if (state === "trial_active") return { title: `Tu prueba gratuita continúa${Number.isFinite(access.trialDaysRemaining) ? ` · ${access.trialDaysRemaining} días restantes` : ""}`, detail: "Hoy podés conocer todas las herramientas. Antes del vencimiento, conservá sólo los módulos que necesite tu negocio; no se cobra automáticamente al terminar la prueba.", action: "Conocer módulos y precios" };
  return { title: "Tu proyecto tiene una suscripción", detail: "Podés revisar las capacidades incluidas y su próxima renovación desde Tu plan.", action: "Ver mi plan" };
}

export function expandBillingSelection(codes = [], services = []) {
  const byCode = new Map(services.map((service) => [service.code, service]));
  const result = new Set();
  function add(code, visiting = new Set()) {
    if (result.has(code) || visiting.has(code)) return;
    const service = byCode.get(code);
    if (!service) return;
    const next = new Set(visiting);
    next.add(code);
    (service.requiredServiceCodes || []).forEach((required) => add(required, next));
    result.add(code);
  }
  codes.forEach((code) => add(code));
  return services.filter((service) => result.has(service.code)).map((service) => service.code);
}

export function billingStarterSelection(services = []) {
  const catalog = services.find((service) => service.code === "products" && service.active !== false);
  const base = services.find((service) => service.code === "landing" && service.active !== false);
  return expandBillingSelection([base?.code, catalog?.code].filter(Boolean), services);
}

export function billingToggleSelection(codes = [], code, services = []) {
  if (codes.includes(code)) {
    const selected = new Set(codes.filter((item) => item !== code));
    let removed = true;
    while (removed) {
      removed = false;
      for (const service of services) {
        if (selected.has(service.code) && (service.requiredServiceCodes || []).some((required) => !selected.has(required))) {
          selected.delete(service.code);
          removed = true;
        }
      }
    }
    return services.filter((service) => selected.has(service.code)).map((service) => service.code);
  }
  return expandBillingSelection([...codes, code], services);
}

export function billingDaysPhase(access = {}) {
  if (!access.isTrial || access.trialExpired) return null;
  const days = Number(access.trialDaysRemaining);
  if (!Number.isFinite(days)) return null;
  if (days <= 1) return "last_day";
  if (days <= 3) return "last_three_days";
  if (days <= 7) return "last_week";
  if (days <= 14) return "halfway";
  return "explore";
}
